<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

  <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <div class="d-flex justify-content-between">
            <p style="font-size: 2vw">درج اطلاعات عملکردی/ {{$route.params.title}}</p>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
          </div>
          <hr>
          <br>
        </center>

         <div class="d-flex flex-nowrap ">
           <div class="card p-4 w-50">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات مالی</p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" :to="`/Financial_management_and_productivity/functional_information/Financial/by/${id_route}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
           <div class="card p-4 w-50 mx-2">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات ستانده</p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" :to="`/Financial_management_and_productivity/functional_information/received/by/${id_route}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
         </div>
        <br>
         <div class="d-flex flex-nowrap ">
           <div class="card p-4 w-50">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات پیامد</p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" :to="`/Financial_management_and_productivity/functional_information/Consequences/by/${id_route}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
           <div class="card p-4 w-50 mx-2">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات اثر</p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" :to="`/Financial_management_and_productivity/functional_information/effect/by/${id_route}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
         </div>



      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      id_route: this.$route['params']['id'],
    }
  },
  methods:{
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
